/* Disabled draft-only explicit ad-data consent binding.
 * No cookies, storage, HTTP, identifiers, events, or required customer fields.
 * The notice and activation require merchant review before use.
 */
(function () {
  "use strict";
  const configNode = document.getElementById("artisan-native-tracking-config");
  let cfg;
  try { cfg = JSON.parse(configNode.textContent); } catch (_) { return; }
  if (cfg.enabled !== true || cfg.explicit_ad_consent_ui_enabled !== true) return;
  // Never replace an existing consent provider or impersonate its approval.
  if (window.ArtisanConsent) return;
  const form = document.getElementById("FreightReviewForm");
  const submit = form && form.querySelector('button[type="submit"]');
  if (!form || !submit) return;
  if (typeof cfg.ad_consent_notice !== "string" || !cfg.ad_consent_notice.trim()) return;
  const label = document.createElement("label");
  label.className = "freight-review__acknowledgment";
  const checkbox = document.createElement("input");
  checkbox.type = "checkbox";
  checkbox.id = "ArtisanAdDataConsent";
  checkbox.checked = false;
  checkbox.required = false;
  // No contact[name] field: evidence goes only in the allowlisted merchant bundle.
  const text = document.createElement("span");
  text.textContent = cfg.ad_consent_notice;
  label.append(checkbox, text);
  form.insertBefore(label, submit);
  let selected = false;
  checkbox.addEventListener("change", () => { selected = checkbox.checked === true; });
  const privacyChanged = () => {
    try {
      const p = window.Shopify && window.Shopify.customerPrivacy;
      const c = p && p.currentVisitorConsent();
      if (!p || !p.marketingAllowed() || !p.saleOfDataAllowed() ||
          c.marketing !== "yes" || c.sale_of_data === "no") {
        selected = false;
        checkbox.checked = false;
      }
    } catch (_) { selected = false; checkbox.checked = false; }
  };
  document.addEventListener("visitorConsentCollected", privacyChanged);
  window.ArtisanConsent = Object.freeze({
    adUserData: () => selected && checkbox.checked === true ? "GRANTED" : "DENIED"
  });
})();
